export default "__VITE_ASSET__4e6d990f__"